import { NgClass } from "@angular/common";
import {
    Component,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { SelectorComponent } from "@components/selector/selector.component";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import { KundorderTyp } from "~app/common/models/constants";
import { TypeaheadService } from "~app/common/services/typeahead/typeahead.service";
import { TypeAhead } from "~app/common/services/typeahead/typeahead.types";
import { IValidationScope } from "~app/common/validation/IValidationScope";
import { OrderService } from "~app/features/forsaljning/order/order.service";
import { DisabledControlDirective } from "../../../../../../common/directives/disabled-control/disabled-control.directive";
import { IAlternativMottagningsplats, IMottagningsplatsTypeAheadResult } from "../../../models/kundorder-detail-model";
import { AlternativaMottagningsplatserComponent } from "../alternativa-mottagningsplatser/alternativa-mottagningsplatser.component";

@Component({
    selector: "rask-kundorderrad-mottagningsplatser",
    templateUrl: "./kundorderrad-mottagningsplatser.component.html",
    styleUrls: ["./kundorderrad-mottagningsplatser.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        SelectorComponent,
        NgClass,
        DisabledControlDirective,
        NgbPopover,
        AlternativaMottagningsplatserComponent,
        TranslatePipe
    ]
})
export class KundorderradMottagningsplatserComponent implements OnInit {
    @Input() form: UntypedFormGroup;

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("alternativaMottagningsplatser") mottagningsplatser: IAlternativMottagningsplats[];
    @Input() newMode: boolean;
    @Input() readonly = false;
    @Input() showLabels = true;
    @Input() typ: string;
    @Input() validation: IValidationScope;

    private readonly orderService = inject(OrderService);
    private readonly translateService = inject(TranslateService);
    private readonly typeaheadService = inject(TypeaheadService);

    private typeaheadKey = "";

    alternativaMottagningsplatserChanged(selection) {
        this.form.controls.alternativaMottagningsplatser.setValue(selection);
    }

    mottagningsplatsDisabled = (item: IMottagningsplatsTypeAheadResult) => !item.aktiv;

    mottagningsplatsViewFormatter = (item: any) => item.mottagningsplatsnummer ? `${item.mottagningsplatsnummer} ${item.namn}` : item.namn;

    ngOnInit(): void {
        this.initTyp();
    }

    searchForMottagningsplats = (input: string): Observable<IMottagningsplatsTypeAheadResult[]> => input.length < 3
        ? this.getPreload(this.typeaheadKey)
        : this.orderService.searchForMottagningsplatsTypeAhead(input, this.typ);

    private getPreload<T>(type: string): Observable<T[]> {
        const defaultText = this.translateService.instant("KUNDORDER_DETAIL_TYPE_AHEAD_HELP_TEXT");
        return of(this.typeaheadService.getPreload<T>(type, defaultText));
    }

    private initTyp() {
        switch (this.typ) {
            case KundorderTyp.Kundorder:
                this.typeaheadKey = TypeAhead.MottagningsplatsKundorder;
                break;
            case KundorderTyp.Terminalorder:
                this.typeaheadKey = TypeAhead.MottagningsplatsTerminalorder;
                break;
        }
    }
}
